export default "__VITE_ASSET__BB4MnC$F__"